import * as React from 'react';
import {RouteComponentProps, withRouter} from 'react-router';
import {ErrorAlert} from '../common/ErrorAlert';
import {
  ApplicationContextConsumer,
  bindLoadingHandler,
  LoadingOverlayHandler,
  withLoadingOverlay
} from '../app/ApplicationContext';
import {showSaveConfirm, showSaveSuccessNotification} from '../utils/dialogs';
import SaleForm from './SaleForm';
import {SaveInventorySaleRequest, ErrorResponse} from '../api/dtos/dtos';
import furoApi from '../api/FuroApi';
import {viewSalePath} from "../paths";

interface CreateSalePageState {
  error?: ErrorResponse;
}

class CreateSalePage extends React.Component<RouteComponentProps, CreateSalePageState> {

  public readonly loadingHandler?: LoadingOverlayHandler;

  public state: CreateSalePageState = {
    error: undefined,
  };

  public render() {
    const {error} = this.state;

    return (
      <>
        <ApplicationContextConsumer>
          {({loadingHandler}) => bindLoadingHandler(loadingHandler, this)}
        </ApplicationContextConsumer>

        <SaleForm onFormSubmit={this.onFormSubmit} onFormCancel={this.onFormCancel}/>

        {error && <ErrorAlert style={{marginTop: '16px'}} error={error}/>}
      </>
    );
  }

  private onFormSubmit = (request: SaveInventorySaleRequest) => {
    showSaveConfirm(() => this.saveFormValues(request));
  };

  private saveFormValues = (request: SaveInventorySaleRequest) => {
    const promise = furoApi.sales.create(request)
      .then(this.onSaveSuccess)
      .catch(this.onApiError);
    withLoadingOverlay(promise, this.loadingHandler);
  };

  private onSaveSuccess = (id: number) => {
    showSaveSuccessNotification();
    this.props.history.replace(viewSalePath(id));
  };

  private onFormCancel = () => {
    this.props.history.goBack();
  };

  private onApiError = (error: ErrorResponse) => {
    this.setState({error});
  };
}

export default withRouter(CreateSalePage);



// WEBPACK FOOTER //
// ./src/sales/CreateSalePage.tsx